import { createDCHook, collapseDataFromCall } from '../client';
import { getUsagesV3 } from '../services/UsageV3Service';

export const useUsageV3GetUsagesV3 = createDCHook('getUsagesV3', collapseDataFromCall(getUsagesV3), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});
